import {
	type UseMutationOptions,
	useMutation,
	useQueryClient
} from '@tanstack/react-query'
import { QUERY_KEYS } from '@/query-client'
import { httpStoreExperienceSubmission } from '../http/experience-shell.http'
import type { Experience } from '../types'

export const useStoreExperienceSubmission = ({
	experienceId,
	options
}: {
	experienceId: number
	options?: Omit<UseMutationOptions<Experience>, 'mutationFn'>
}) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: () =>
			httpStoreExperienceSubmission({
				params: { responseType: 'extended' },
				urlParams: { experienceId }
			}),
		...options,
		onSuccess: (data, variables, onMutateResult, context) => {
			queryClient.cancelQueries({
				queryKey: [QUERY_KEYS.EXPERIENCE, experienceId]
			})
			queryClient.setQueriesData(
				{ queryKey: [QUERY_KEYS.EXPERIENCE, experienceId] },
				data
			)
			options?.onSuccess?.(data, variables, onMutateResult, context)
		}
	})
}
